import PlayerClassic from './player-classic';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import Action from 'actions';
import Const from 'const';
import {getDefaultExposure} from 'helpers/player-helper';

export default class PlayerTiers extends PlayerClassic {
    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnProperty('gameInfo');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    getExpandedEntityParams({incomingValues = {}}) {
        const {userPointsType = 'adminPoints'} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});
        const userPoints = parseFloat(expandedPlayer[userPointsType]);

        return {
            ...expandedPlayer,
            [Const.EXCLUDED_BY_LINE_GROUPS_RANGE]: false,
            userPoints: userPoints,
            lineGroup: parseInt(expandedPlayer.lineGroup * 1),
            userLineGroup: parseInt(expandedPlayer.lineGroup * 1),
            ppLine: parseInt(expandedPlayer.ppLine * 1),
            userPpLine: parseInt(expandedPlayer.ppLine * 1),
            isExcludedByFilter() {
                return this[Const.EXCLUDED_BY_LINE_GROUPS_RANGE];
            },
            include() {
                this.includeBy([Const.EXCLUDED_BY_LINE_GROUPS_RANGE]);
            },
            isGoalie() {
                return this.positionName === 'G';
            },
            isDefenseman() {
                return this.positionName === 'D';
            },
            resetExposure() {
                this.exposureMin = getDefaultExposure('min');
                this.exposureMax = getDefaultExposure('max');
            },
            resetPPLine() {
                this.userPpLine = this.ppLine;
            },
            resetLineGroups() {
                this.userLineGroup = this.lineGroup;
            },
            isFitForLineup(substitutablePlayer) {
                return substitutablePlayer.rosterPositionName === this.rosterPositionName;
            },
        };
    }
}
